module.exports = __webpack_public_path__ + "img/Ching.43ed86e5.jpg";